"use client";

import { useState } from "react";
import { ArrowRight } from "lucide-react";
import Image from "next/image";

const tabs = [
  {
    id: "whiteboard",
    label: "Whiteboard",
    title: "Where your team creates winning ads Creatives",
    body: "Capture inspiration, Create Copy creatives from ad copy, generate image , video scrips organize briefs, and compare brands — all in one AI-powered Whitespace.",
    cta: "Open Whiteboard",
    href: "https://app.imagive.ai?redirect=/users/white-chat-board",
    image: "/assets/workspaceAssets/whiteboard.svg",
  },
  {
    id: "chat",
    label: "Imagive Chat Assistant",
    title: "Your AI Assistant for ideas, insights, and execution",
    body: "Transform ideas into high-performing campaigns with AI-powered research, creative generation, competitor analysis, and strategic recommendations.",
    cta: "Explore Imagive assistant",
    href: "https://app.imagive.ai?redirect=/users/chat-ui",
    image: "/assets/workspaceAssets/imagive-chat.svg",
  },
  {
    id: "brandkit",
    label: "Brand Kit",
    title: 'One source of truth for everything that\'s "you"',
    body: "Centralize your visual identity, tone of voice, and creative guidelines. Give your team and AI the context they need to create consistently.",
    cta: "Add your Brand Kit",
    href: "https://app.imagive.ai?redirect=/users/brands",
    image: "/assets/workspaceAssets/brand-kit.svg",
  },
  {
    id: "library",
    label: "Imagive Library",
    title: "Every asset, every variation, searchable in seconds",
    body: "Every ad you've generated, tested, launched, or shelved stored, tagged, and performance-tracked. Search by hook, by ROAS, by date. The library remembers what your spreadsheet forgets.",
    cta: "Open imagive library",
    href: "https://app.imagive.ai?redirect=/users/ads-library",
    image: "/assets/workspaceAssets/imagive-library.svg",
  },
];

const TeamCollaboration = () => {
  const [active, setActive] = useState(0);
  const tab = tabs[active];

  return (
    <section className="w-full bg-white px-5 py-16 sm:px-6 lg:px-20 lg:py-24">
      {/* heading row */}
      <div className="grid grid-cols-1 gap-6 lg:grid-cols-2 lg:items-end lg:gap-16">
        <h2 className="solution-sub-heading">
          Everything your team
          <br /> needs to create together.
        </h2>
        <p className="max-w-[450px] body-secondary-text">
          Tap any tab to open it each pillar works on its own but shines when
          your team uses them together.
        </p>
      </div>

      {/* tabbed panel */}
      <div className="mt-12 overflow-hidden rounded-2xl border border-black/[0.08] bg-white shadow-sm">
        {/* tab bar */}
        <div className="flex gap-x-6 overflow-x-auto border-b border-black/[0.08] px-5 [-ms-overflow-style:none] [scrollbar-width:none] sm:gap-x-12 sm:px-8 lg:gap-x-20 [&::-webkit-scrollbar]:hidden">
          {tabs.map((t, i) => (
            <button
              key={t.id}
              onClick={() => setActive(i)}
              className={`relative -mb-px shrink-0 whitespace-nowrap py-4 text-[13px] font-medium transition-colors sm:text-[14px] ${
                i === active
                  ? "text-[#1D1D1F]"
                  : "text-[#9A9AA5] hover:text-[#6D6D75]"
              }`}
            >
              <span className="mr-1 tabular-nums text-[#9A9AA5]">
                {String(i + 1).padStart(2, "0")}
              </span>
              {t.label}
              {i === active && (
                <span className="absolute inset-x-0 -bottom-px h-0.5 rounded-full bg-[#1D1D1F]" />
              )}
            </button>
          ))}
        </div>

        {/* content */}
        <div className="grid grid-cols-1 gap-8 p-6 sm:p-10 lg:grid-cols-2 lg:items-center lg:gap-12">
          <div key={tab.id} className="tab-fade-in">
            <h3 className="text-[24px]  max-w-[400px] font-medium leading-[1.2] tracking-[-0.5px] text-[#1D1D1F] lg:text-[30px]">
              {tab.title}
            </h3>
            <p className="mt-4 max-w-[440px] text-[14px] leading-[1.7] text-[#6D6D75]">
              {tab.body}
            </p>
            <a
              href={tab.href}
              target="_blank"
              rel="noopener noreferrer"
              className="group mt-5 inline-flex items-center gap-1.5 text-[14px] font-medium text-[#3232AA]"
            >
              {tab.cta}
              <ArrowRight
                size={15}
                className="transition-transform duration-300 group-hover:translate-x-1"
              />
            </a>
          </div>

          {/* preview image */}
          <div key={`${tab.id}-img`} className="tab-fade-in w-full">
            <Image
              src={tab.image}
              alt={tab.label}
              width={1000}
              height={700}
              className="h-auto w-full"
              priority
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default TeamCollaboration;
